import React from "react";
import { View, Text, Linking } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import BenefitItem from "./BenefitItem";
import { storageUtils } from "@/utils/storage";
import { ActionButton } from "@/components/ActionButton";
import { APP_BASE_URL } from "@/constants/Configs";
import { FontFamilies } from "@/constants/Typography";
import Icons from "@/assets/icons";
import useUserStore from "@/store/user";
import { router } from "expo-router";
import { isWeb } from "@/utils/platform";
import { Colors } from "@/constants/Colors";

const AddPaymentMethodCard: React.FC = () => {
  const { getUserProfile, isFreePlan, userProfile } = useUserStore();
  const userCredits = userProfile?.userCredits;
  const benefits = [
    !isWeb && "Invite friends to earn extra claims",
    "Upgrade for unlimited claims",
    "Sparrow takes care of calls and paperwork",
  ];

  const onPressActivate = async () => {
    if (isWeb) {
      const sessionId = storageUtils.getSessionId();
      const popup = window.open(
        `${APP_BASE_URL}/pay?sessionId=${sessionId}&redirectUrl=localhost:8081`,
        "paymentPopup",
        "width=500,height=600"
      );
      const handleMessage = (event: any) => {
        if (event.origin !== APP_BASE_URL) return;
        if (event.data?.type === "payment-success") {
          popup?.close();
          getUserProfile();
        }
        if (event.data?.type === "payment-cancel") {
          popup?.close();
        }
      };
      window.addEventListener("message", handleMessage);
      const interval = setInterval(() => {
        if (popup?.closed) {
          clearInterval(interval);
          window.removeEventListener("message", handleMessage);
        }
      }, 500);
      return;
    }
    // Native platforms use IAP
    router.push("/subscription/upgrade");
    // await requestSubscription();
  };

  const remainingClaims = Number(userCredits || 0);
  const remainingClaimsText = remainingClaims === 1 ? "claim" : "claims";

  return (
    <View style={styles.container}>
      {!isWeb && isFreePlan && (
        <Text style={styles.norText}>
          You have{" "}
          <Text style={styles.boldText}>
            {remainingClaims} free {remainingClaimsText}
          </Text>{" "}
          left this month. Claims reset first the day of the month.
        </Text>
      )}

      <View style={styles.benefitsContainer}>
        {benefits.map(
          (benefit, index) =>
            benefit && <BenefitItem key={index} text={benefit} />
        )}
      </View>

      <ActionButton
        title="Upgrade to Unlimited"
        onPress={onPressActivate}
        icon={isWeb ? <Icons.OpenLink /> : undefined}
        iconPosition="right"
      />
      <Text style={styles.termsText}>
        <Text
          style={styles.termsTextLink}
          onPress={() => Linking.openURL("https://usesparrow.com/terms")}
        >
          Terms of Use
        </Text>{" "}
        and{" "}
        <Text
          style={styles.termsTextLink}
          onPress={() => Linking.openURL("https://usesparrow.com/privacy")}
        >
          Privacy Policy
        </Text>
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 20,
  },
  norText: {
    fontSize: 14,
    fontFamily: FontFamilies.InterTight.Regular,
    color: "#161D14",
    marginBottom: 12,
    lineHeight: 20,
  },
  boldText: {
    fontFamily: FontFamilies.InterTight.SemiBold,
  },
  benefitsContainer: {
    marginBottom: 24,
  },
  termsText: {
    marginTop: 12,
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 12,
    lineHeight: 15,
    color: "#414141",
    textAlign: "center",
  },
  termsTextLink: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 12,
    lineHeight: 15,
    color: Colors.primary,
  },
});

export default AddPaymentMethodCard;
